import Header from "../../../../components/common/Header";
import Icon from "../../../../components/common/Icon";
import {useEffect, useState} from "react";
import useAuth from "../../../../hooks/useAuth";
import {
    getCmsTextList, uploadTextPositionDown, uploadTextPositionUp
} from "../../../../api/admin/cmsReq";

export default function ViewCmsTextOrder({category}) {

    const source = "fa fa-table-list";
    const [ cmsTextList, setCmsTextList ] = useState();
    const { auth } = useAuth();
    const token = auth.token;

    const apiTextList = async () => {
        const response = await getCmsTextList(category)
        setCmsTextList(response)
    }

    const handleLegalUp = async (id) => {
        await uploadTextPositionUp(token, id, category)
        apiTextList()
    }

    const handleLegalDown = async (id) => {
        await uploadTextPositionDown(token, id, category)
        apiTextList()
    }

    useEffect(() => {
        apiTextList()
    }, [ category ]);

    let location;
    switch (category) {
        case 3:
            location = "Cms : Mentions légales";
            break;
        case 4:
            location = "Cms : Cookies";
            break;
        case 5:
            location = "Cms : Données personnelles";
            break;
        default:
            location = "Cms : Texte formulaires";
    }

    return (
        <main className="admin">
            <Header
                parent="Administration"
                location={location}
            />
            <div className="flex">
                <div className="dashboard">
                    <Icon source={source} color="blue" span="Ordre des textes de mentions légales"/>
                    <table>
                        <thead>
                        <tr>
                            <th>Position</th>
                            <th>Titre</th>
                            <th>Déplacement</th>
                        </tr>
                        </thead>
                        <tbody>
                        {cmsTextList?.map(text => (
                            <tr>
                                <td>{text?.position}</td>
                                <td>{text?.title}</td>
                                <td className="up-down-section">
                                    <i className="fa fa-arrow-down" onClick={() => handleLegalUp(text?.id)}></i>
                                    <i className="fa fa-arrow-up" onClick={() => handleLegalDown(text?.id)}></i>
                                </td>
                            </tr>
                        ))
                        }
                        </tbody>
                    </table>
                    <div className="flex-buttons">
                        <button className="red-button"><i className="fa fa-close"/>Annuler</button>
                    </div>
                </div>
            </div>
            {/*TODO bouton retour sur autres "orders" aussi */}
        </main>
    )
}